module.exports = __webpack_public_path__ + "resources/img/img_text_to_speech2_en_m.3c46630daac76e7771216877a588a181.png";